import { Stack } from '../../features/models/github.interface';

/**
 * Interface for date formatting operations
 */
export interface IDateFormatter {
  formatDate(techDate: Stack): string;
}

/**
 * Interface for status calculation strategies
 */
export interface IStatusCalculator {
  calculateStatus(techStack: Stack, yearsInAdvance?: number): string;
  canHandle(techName: string): boolean;
}

/**
 * Interface for version operations
 */
export interface IVersionService {
  getRecommendedVersion(
    techName: string,
    eolStack: any[],
    currentVersion?: string,
  ): string;
}

/**
 * Status classes constants
 */
export const STATUS_CLASSES = {
  good: 'status-good',
  caution: 'status-caution',
  danger: 'status-danger',
  gray: 'status-gray',
} as const;

export type StatusClass = (typeof STATUS_CLASSES)[keyof typeof STATUS_CLASSES];
